export default __webpack_public_path__ + "static/media/featured_tour_03.70771fee.png";